export default {"src":"/_next/static/media/sai.b3fbe714.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};